export const TIME = [
  { time: 0, label: '00' },
  { time: 1, label: '01' },
  { time: 2, label: '02' },
  { time: 3, label: '03' },
  { time: 4, label: '04' },
  { time: 5, label: '05' },
  { time: 6, label: '06' },
  { time: 7, label: '07' },
  { time: 8, label: '08' },
  { time: 9, label: '09' },
  { time: 10, label: '10' },
  { time: 11, label: '11' },
  { time: 12, label: '12' },
  { time: 13, label: '13' },
  { time: 14, label: '14' },
  { time: 15, label: '15' },
  { time: 16, label: '16' },
  { time: 17, label: '17' },
  { time: 18, label: '18' },
  { time: 19, label: '19' },
  { time: 20, label: '20' },
  { time: 21, label: '21' },
  { time: 22, label: '22' },
  { time: 23, label: '23' },
];

export const INTERVAL_FIVE_MINUTE = [
  { minute: 0, label: '00' },
  { minute: 5, label: '05' },
  { minute: 10, label: '10' },
  { minute: 15, label: '15' },
  { minute: 20, label: '20' },
  { minute: 25, label: '25' },
  { minute: 30, label: '30' },
  { minute: 35, label: '35' },
  { minute: 40, label: '40' },
  { minute: 45, label: '45' },
  { minute: 50, label: '50' },
  { minute: 55, label: '55' },
];

export const MINUTE = [
  { minute: 0, label: '00' },
  { minute: 1, label: '01' },
  { minute: 2, label: '02' },
  { minute: 3, label: '03' },
  { minute: 4, label: '04' },
  { minute: 5, label: '05' },
  { minute: 6, label: '06' },
  { minute: 7, label: '07' },
  { minute: 8, label: '08' },
  { minute: 9, label: '09' },
  { minute: 10, label: '10' },
  { minute: 11, label: '11' },
  { minute: 12, label: '12' },
  { minute: 13, label: '13' },
  { minute: 14, label: '14' },
  { minute: 15, label: '15' },
  { minute: 16, label: '16' },
  { minute: 17, label: '17' },
  { minute: 18, label: '18' },
  { minute: 19, label: '19' },
  { minute: 20, label: '20' },
  { minute: 21, label: '21' },
  { minute: 22, label: '22' },
  { minute: 23, label: '23' },
  { minute: 24, label: '24' },
  { minute: 25, label: '25' },
  { minute: 26, label: '26' },
  { minute: 27, label: '27' },
  { minute: 28, label: '28' },
  { minute: 29, label: '29' },
  { minute: 30, label: '30' },
  { minute: 31, label: '31' },
  { minute: 32, label: '32' },
  { minute: 33, label: '33' },
  { minute: 34, label: '34' },
  { minute: 35, label: '35' },
  { minute: 36, label: '36' },
  { minute: 37, label: '37' },
  { minute: 38, label: '38' },
  { minute: 39, label: '39' },
  { minute: 40, label: '40' },
  { minute: 41, label: '41' },
  { minute: 42, label: '42' },
  { minute: 43, label: '43' },
  { minute: 44, label: '44' },
  { minute: 45, label: '45' },
  { minute: 46, label: '46' },
  { minute: 47, label: '47' },
  { minute: 48, label: '48' },
  { minute: 49, label: '49' },
  { minute: 50, label: '50' },
  { minute: 51, label: '51' },
  { minute: 52, label: '52' },
  { minute: 53, label: '53' },
  { minute: 54, label: '54' },
  { minute: 55, label: '55' },
  { minute: 56, label: '56' },
  { minute: 57, label: '57' },
  { minute: 58, label: '58' },
  { minute: 59, label: '59' },
];

export const WEEK = [{ week: 0, label: '일요일' }, { week: 1, label: '월요일' }, { week: 2, label: '화요일' }, { week: 3, label: '수요일' }, { week: 4, label: '목요일' }, { week: 5, label: '금요일' }, { week: 6, label: '토요일' }];

export const MONTH = [
  { value: 1, label: '1월' },
  { value: 2, label: '2월' },
  { value: 3, label: '3월' },
  { value: 4, label: '4월' },
  { value: 5, label: '5월' },
  { value: 6, label: '6월' },
  { value: 7, label: '7월' },
  { value: 8, label: '8월' },
  { value: 9, label: '9월' },
  { value: 10, label: '10월' },
  { value: 11, label: '11월' },
  { value: 12, label: '12월' },
];



// WEBPACK FOOTER //
// ./src/constants/date.js